export default "__VITE_ASSET__Bh_ZL6I7__"